import { render, staticRenderFns } from "./userApprove.vue?vue&type=template&id=89278900&scoped=true&lang=pug"
import script from "./userApprove.vue?vue&type=script&lang=js"
export * from "./userApprove.vue?vue&type=script&lang=js"
import style0 from "./userApprove.vue?vue&type=style&index=0&id=89278900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89278900",
  null
  
)

export default component.exports